module.exports = __webpack_public_path__ + "static/media/user-4.2cb941cc.png";